/**
 * Util function to be used as default parameter for callbacks, or optional functions
 * implementations.
 *
 * @internal
 */
export function noOp(): any {}
